import { render, staticRenderFns } from "./activeData.vue?vue&type=template&id=92e10b88&scoped=true&"
import script from "./activeData.vue?vue&type=script&lang=js&"
export * from "./activeData.vue?vue&type=script&lang=js&"
import style0 from "./activeData.vue?vue&type=style&index=0&id=92e10b88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e10b88",
  null
  
)

export default component.exports